import React, { useState, useEffect, useMemo, useRef } from "react";
import Input from "../sub-component/Input";
import CustomTooltip from "./CustomTooltip";
import Select from "../sub-component/Select";
import Checkbox from "../sub-component/Checkbox";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import Pagination from "../sub-component/Pagination";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useFocusWithin } from "@react-aria/interactions";
import {
  utcFormatDate,
  formatDate,
  localTimeDifference,
} from "../../utils/utilities";
import ProcessingIndicator from "../common/ProcessingIndicator";
import { ReactComponent as BackArrow } from "../../assets/icons/Arrows/CaretLeft.svg";
import { ReactComponent as ForwardArrow } from "../../assets/icons/Arrows/CaretRight.svg";
import { ReactComponent as Filter } from "../../assets/icons/components/common/table/filter1.svg";
import { ReactComponent as Search } from "../../assets/icons/Views/candidate/assessments/search.svg";
import { ReactComponent as ArrowUp } from "../../assets/icons/components/common/table/chevron-up-1.svg";
import { ReactComponent as SearchCrossIcon } from "../../assets/icons/Views/dashboard/assessments/x.svg";
import { ReactComponent as Reject } from "../../assets/icons/Views/dashboard/test-detail/user-minus.svg";
import { ReactComponent as Shortlist } from "../../assets/icons/Views/dashboard/test-detail/user-check.svg";
import { ReactComponent as ArrowDown } from "../../assets/icons/components/common/table/chevron-down-1.svg";

export default function Table(props) {
  const {
    data,
    customSorting,
    setHighlightActiveRow,
    searchColumns,
    testDetails,
    children,
    setData,
    selectedId,
    customSearch,
    backendFilter,
    setSelectedsortOption,
    selectedsortOption,
    onSelectRow,
    assessSpecRowClick,
  } = props;

  const history = useHistory();
  const location = useLocation();

  const [sorting, setSorting] = useState({
    header: null,
    column: null,
    order: "none",
    clickCount: 0,
  });
  const [searchItem, setSearchItem] = useState("");
  const [openFilterCard, setOpenFilterCard] = useState(false);
  const [headers, setHeaders] = useState(props?.headers);
  const [headerLength, setheaderLength] = useState(props?.headers?.length);
  const [headerCheckboxState, setHeaderCheckboxState] = useState("");

  const [filteredData, setFilteredData] = useState([]);
  const [headerFilters, setHeaderFilters] = useState({});
  const [filterDropdowns, setFilterDropdowns] = useState("");

  const [totalPages, setTotalPages] = useState(1);
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(
    localStorage?.getItem("page")
      ? parseInt(`${localStorage?.getItem("page")}`)
      : 1,
  );

  const [rowsPerPage, setRowsPerPage] = useState(props?.itemsPerPage || 10);
  const [start, setStart] = useState(
    localStorage?.getItem("page")
      ? (parseInt(`${localStorage?.getItem("page")}`) - 1) * 10
      : 0,
  );
  const [Finish, setFinish] = useState(
    localStorage?.getItem("page")
      ? parseInt(`${localStorage?.getItem("page")}`) * 10
      : 10,
  );
  const [slideIndex, setSlideIndex] = useState(1);
  const [filteredRow, setFilteredRow] = useState([]);
  const [isTableSearchInputOpen, setIsTableSearchInputOpen] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeRow, setActiveRow] = useState(-1);

  const isOnWebScreen = useMediaQuery("(min-width:1365px)");
  const isOnTabletScreen = useMediaQuery(
    "(min-width:901px) and (max-width:1364px)",
  );
  const isOnMiniTabletScreen = useMediaQuery(
    "(min-width:768px) and (max-width:900px)",
  );
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");

  Array.prototype.sortBy = function (p, type, requirement) {
    if (type === "string") {
      return this.slice(0).sort(function (a, b) {
        const StringA = a[p] ? a[p].toLowerCase() : "";
        const StringB = b[p] ? b[p].toLowerCase() : "";
        return StringA > StringB ? 1 : StringA < StringB ? -1 : 0;
      });
    } else if (type === "number") {
      return this.slice(0).sort(function (a, b) {
        const numberA = isNaN(parseInt(a[p]))
          ? 0
          : parseInt(a[p].toString().replaceAll(":", "").replaceAll("-", ""));
        const numberB = isNaN(parseInt(b[p]))
          ? 0
          : parseInt(b[p].toString().replaceAll(":", "").replaceAll("-", ""));
        return numberA > numberB ? 1 : numberA < numberB ? -1 : 0;
      });
    }
  };

  Array.prototype.sortByDec = function (p, type, requirement) {
    if (type === "string") {
      return this.slice(0).sort(function (a, b) {
        const StringA = a[p] ? a[p].toLowerCase() : "";
        const StringB = b[p] ? b[p].toLowerCase() : "";
        return StringA < StringB ? 1 : StringA > StringB ? -1 : 0;
      });
    } else if (type === "number") {
      return this.slice(0).sort(function (a, b) {
        const numberA = isNaN(parseInt(a[p]))
          ? 0
          : parseInt(a[p].toString().replaceAll(":", "").replaceAll("-", ""));
        const numberB = isNaN(parseInt(b[p]))
          ? 0
          : parseInt(b[p].toString().replaceAll(":", "").replaceAll("-", ""));
        return numberA < numberB ? 1 : numberA > numberB ? -1 : 0;
      });
    }
  };

  useEffect(() => {
    setRows([...data]);
    setFilteredRow([...data]);
  }, [data]);

  useEffect(() => {
    setHeaders(props?.headers);
  }, [props?.headers]);

  useEffect(() => {
    setFilteredRow(filteredData);
  }, [filteredData]);

  useEffect(() => {
    setRows(getCurrentPageData());
    const totalPages = Math.ceil(filteredRow?.length / rowsPerPage) || 0;
    setTotalPages(totalPages);
  }, [rowsPerPage, filteredRow]);

  useEffect(() => {
    if (currentPage) {
      setRows(getCurrentPageData());
    }
  }, [currentPage]);

  useEffect(() => {
    if (customSearch) {
      handleSearchChange(customSearch);
    }
  }, [customSearch]);

  useEffect(() => {
    if (selectedId) {
      const activeRowId = rows?.findIndex((row) => row?.id === selectedId);
      setActiveRow(activeRowId);
    }
  }, [selectedId, rows]);

  useEffect(() => {
    const headers = props?.headers;
    let _headerLength = props?.headers?.length;
    if (isOnTabletScreen) {
      _headerLength = headers?.filter((header) =>
        header?.screens?.includes("tab"),
      )?.length;
    }
    if (isOnMiniTabletScreen) {
      _headerLength = headers?.filter((header) =>
        header?.screens?.includes("mini_tab"),
      )?.length;
    }
    if (isOnMobileScreen) {
      _headerLength = headers?.filter((header) =>
        header?.screens?.includes("mob"),
      )?.length;
    }
    if (props?.showActions) {
      headers?.push({ name: "Actions", type: "actions", disableSorting: true });
      _headerLength += 1;
    }

    setheaderLength(_headerLength);
  }, [
    props?.headers,
    isOnTabletScreen,
    isOnMiniTabletScreen,
    isOnMobileScreen,
  ]);

  const sortAssending = (byColumn) => {
    const { value, type, requirement } = byColumn;
    if (data) {
      var sortedObjs = [];
      sortedObjs = data?.sortBy(value, type, requirement);
    }
    setFilteredRow(sortedObjs);
  };

  const handleSelectRow = (index) => {
    props?.handleRowSelect?.(index, "single");
    setHeaderCheckboxState(getCheckboxState(rows));
  };

  const selectedItemsCount = () => {
    let count = 0;
    filteredRow?.forEach((item) => {
      if (item?.selected) {
        count += 1;
      }
    });
    return count;
  };

  const getCheckboxState = (items) => {
    const anySelected = items?.length && items?.some((item) => item?.selected);
    const allSelected = items?.length && items?.every((item) => item?.selected);

    if (anySelected && !allSelected) {
      return "indeterminate";
    } else if (allSelected) {
      return "checked";
    } else {
      return "";
    }
  };

  const handleSelectAll = () => {
    const selectedIds = rows?.map((row) => row?.id);
    if (headerCheckboxState === "checked") {
      props?.handleRowSelect?.(selectedIds, headerCheckboxState, false);
    } else if (headerCheckboxState === "indeterminate") {
      props?.handleRowSelect?.(selectedIds, headerCheckboxState, false);
    } else {
      props?.handleRowSelect?.(selectedIds, headerCheckboxState, true);
    }
    setHeaderCheckboxState(getCheckboxState(rows));
  };

  const handleBulkUpdate = async (hiringStage) => {
    const assessments = data?.map((assesment) =>
      assesment?.selected
        ? {
            ...assesment,
            hiringStage: `${
              hiringStage?.charAt(0)?.toUpperCase() +
              hiringStage?.toLowerCase()?.slice(1)
            }`,
            hiring_stage: hiringStage,
          }
        : { ...assesment },
    );
    const selectedIds = data
      ?.map((assesment) => assesment?.selected && assesment?.id)
      ?.filter((item) => item);
    props?.handleBulkUpdate?.(selectedIds, hiringStage, assessments);
  };

  const sortDessending = (byColumn) => {
    const { value, type, requirement } = byColumn;
    if (data) {
      var sortedObjs = [];
      sortedObjs = data?.sortByDec(value, type, requirement);
    }
    setFilteredRow(sortedObjs);
  };

  const getCurrentPageData = () => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    let endIndex = startIndex + rowsPerPage;

    endIndex = Math.min(endIndex, data?.length || 0);

    setHeaderCheckboxState(
      getCheckboxState(filteredRow?.slice(startIndex, endIndex) || []),
    );

    return filteredRow?.slice(startIndex, endIndex) || [];
  };

  // useEffect(() => {
  //   if (!rows?.length && filteredData?.length && currentPage > 1) {
  //     setCurrentPage(currentPage - 1);
  //   }
  // }, [rows]);

  useEffect(() => {
    let filtered = [...data];
    Object.keys(headerFilters)?.forEach((columnName) => {
      const filterValue = headerFilters[columnName];
      if (filterValue) {
        filtered = filtered?.filter(
          (item) => item?.[columnName]?.toString() === filterValue?.value,
        );
      }
    });

    if (searchItem && !backendFilter) {
      filtered = filtered?.filter((row) => {
        if (testDetails && row?.user) {
          return searchColumns?.some((col) => {
            return row?.user?.[col]
              ?.toString()
              ?.toLowerCase()
              ?.includes(searchItem?.toLowerCase());
          });
        } else {
          return searchColumns?.some((col) => {
            if (col === "hiringStage" && row?.[col] === "Pending") {
              return "Not Yet Evaluated"
                ?.toString()
                ?.toLowerCase()
                ?.includes(searchItem?.toLowerCase());
            }
            return (
              row?.[col] &&
              row?.[col]
                ?.toString()
                ?.toLowerCase()
                ?.includes(searchItem?.toLowerCase())
            );
          });
        }
      });
    }

    if (sorting?.order === "none" || backendFilter) {
      setFilteredData(filtered);
      setTimeout(() => {
        setLoading(false);
      }, 200);
    } else {
      if (!filtered || !Array.isArray(filtered)) {
        setFilteredData([]);
        setLoading(false);
        return;
      }

      filtered?.sort((a, b) => {
        if (!a || !b) return 0;

        const sortFn = customSorting?.[sorting?.header?.id];
        if (!sortFn) return 0;

        const valueA = a?.[sorting?.header?.id];
        const valueB = b?.[sorting?.header?.id];

        if (valueA === undefined || valueB === undefined) return 0;

        try {
          if (sorting?.order === "asc") {
            return sortFn(valueA, valueB);
          } else {
            return sortFn(valueB, valueA);
          }
        } catch (error) {
          console.error("Sorting error:", error);
          return 0;
        }
      });

      setFilteredData(filtered);
      setTimeout(() => {
        setLoading(false);
      }, 200);
    }
    setOpenFilterCard(false);
  }, [data, headers, headerFilters, searchItem, sorting]);

  const updateQueryParams = (filters) => {
    const params = new URLSearchParams(location?.search);
    Object.entries(filters)?.forEach(([key, value]) => {
      if (value) {
        params.set(key, value?.value);
      } else {
        params.delete(key);
      }
    });
    history?.replace({ search: params?.toString() });
  };

  const handleFilterChange = (columnName, filterValue) => {
    setCurrentPage(1);
    setStart(0);
    setFinish(10);
    const newFilters = {
      ...headerFilters,
      [columnName]: filterValue,
    };
    setHeaderFilters(newFilters);
    updateQueryParams(newFilters);
  };

  const handleResetFIlter = (columnName) => {
    setCurrentPage(1);
    setStart(0);
    setFinish(10);
    const newFilters = {
      ...headerFilters,
      [columnName]: null,
    };
    setHeaderFilters(newFilters);
    updateQueryParams(newFilters);
    handleOpenFilterCard();
  };

  const SEARCH_DEBOUNCE_MS = 500;
  const MIN_SEARCH_CHARS = 1;
  const searchUpdateTimeout = useRef(null);

  const updateSearchQueryParams = (searchValue) => {
    const params = new URLSearchParams(location?.search);
    if (searchValue) {
      params.set("search", searchValue);
    } else {
      params.delete("search");
    }
    history?.replace({ search: params?.toString() });
  };

  const handleCancelSearch = () => {
    const searchValue = "";
    setSearchItem(searchValue);
    updateSearchQueryParams(searchValue);
  };

  const handleSearchChange = (e) => {
    setCurrentPage(1);
    setStart(0);
    setFinish(10);
    const searchValue = e?.target?.value;
    setSearchItem(searchValue);

    if (searchUpdateTimeout.current) {
      clearTimeout(searchUpdateTimeout.current);
    }

    if (!searchValue) {
      updateSearchQueryParams(searchValue);
      return;
    }

    searchUpdateTimeout.current = setTimeout(() => {
      updateSearchQueryParams(searchValue);
    }, SEARCH_DEBOUNCE_MS);
  };

  useEffect(() => {
    return () => {
      if (searchUpdateTimeout.current) {
        clearTimeout(searchUpdateTimeout.current);
      }
    };
  }, []);

  useMemo(() => {
    setRows(filteredRow?.slice(start, Finish));
  }, [filteredRow, start, Finish]);

  useEffect(() => {
    const params = new URLSearchParams(location?.search);
    if (params.get("page") && !backendFilter) {
      localStorage?.setItem("page", parseInt(`${params.get("page")}`));
    } else {
      localStorage.removeItem("page");
      setCurrentPage(1);
      setStart(0);
      setFinish(10);
    }
  }, [currentPage]);

  useEffect(() => {
    // Load saved state from localStorage
    const savedSorting = localStorage?.getItem("tableSorting");
    const savedFilters = localStorage?.getItem("tableFilters");
    if (savedSorting) {
      setSorting(JSON.parse(savedSorting));
    }
    if (savedFilters) {
      setHeaderFilters(JSON.parse(savedFilters));
    }
  }, []);

  useEffect(() => {
    setRowsPerPage(props?.itemsPerPage);
  }, [props?.itemsPerPage]);

  const handleOpenFilterCard = (columnName) => {
    setFilterDropdowns(columnName);
    setOpenFilterCard(!openFilterCard);
  };

  const { focusWithinProps } = useFocusWithin({
    onFocusWithin: (e) => {},
    onBlurWithin: (e) => {
      setOpenFilterCard(false);
    },
  });

  const handleSort = (header) => {
    if (header?.disableSorting) return;

    const currentSorting = { ...sorting };

    // Cycle through sorting states: none -> asc -> desc -> none
    if (currentSorting?.column === header?.name) {
      if (currentSorting?.order === "none") {
        currentSorting.order = "asc";
      } else if (currentSorting?.order === "asc") {
        currentSorting.order = "desc";
      } else {
        currentSorting.order = "none";
        currentSorting.header = null;
        currentSorting.column = null;
      }
    } else {
      currentSorting.header = header;
      currentSorting.column = header?.name;
      currentSorting.order = "asc";
    }

    setSorting(currentSorting);
    setCurrentPage(1);
    setStart(0);
    setFinish(10);
    setLoading(true);

    // Update URL params with sorting
    const params = new URLSearchParams(location?.search);
    if (currentSorting?.order === "none") {
      params.delete("sortColumn");
      params.delete("sortOrder");
    } else {
      params.set("sortColumn", currentSorting?.column);
      params.set("sortOrder", currentSorting?.order);
    }
    history?.replace({ search: params?.toString() });
    localStorage?.setItem("tableSorting", JSON.stringify(currentSorting));
  };

  const nextSlide = () => {
    const params = new URLSearchParams(location?.search);
    const row = filteredRow?.slice(start, Finish);
    if (data?.length > 10) {
      setCurrentPage(currentPage + 1);
      params.set("page", currentPage + 1);
    }
    history?.replace({ search: params?.toString() });

    if (row?.length < 10) {
      return;
    }
    if (slideIndex !== row?.length) {
      setStart(start + 10);
      setFinish(Finish + 10);
    } else if (slideIndex === row?.length) {
      setStart(0);
      setFinish(10);
    }
  };

  const prevSlide = () => {
    const params = new URLSearchParams(location?.search);
    setCurrentPage(currentPage - 1);
    setStart(start - 10);
    setFinish(Finish - 10);
    if (currentPage > 1) {
      params.set("page", currentPage - 1);
    }
    history?.replace({ search: params?.toString() });
  };

  const handleBackendSort = (header) => {
    const currentSorting = { ...selectedsortOption };

    if (currentSorting?.column === header?.id) {
      if (currentSorting?.order === "DESC") {
        currentSorting.order = "ASC";
      } else if (currentSorting?.order === "ASC") {
        currentSorting.order = "none";
      } else {
        currentSorting.order = "DESC";
      }
    } else {
      currentSorting.column = header?.id;
      currentSorting.order = "DESC";
    }

    props?.setCurrentPage?.(1);
    setSelectedsortOption(currentSorting);

    // Update URL params with backend sorting
    const params = new URLSearchParams(location?.search);
    if (currentSorting?.order === "none") {
      params.delete("sortColumn");
      params.delete("sortOrder");
    } else {
      params.set("sortColumn", currentSorting?.column);
      params.set("sortOrder", currentSorting?.order);
    }
    history?.replace({ search: params?.toString() });
  };

  const handleRowClick = (row) => {
    history?.push(`/dashboard/assessments/${row?.spec_id}?result=${row?.id}`);
  };

  useEffect(() => {
    // Load filters from query params
    const params = new URLSearchParams(location?.search);
    let initialFilters = {};

    props?.headers?.forEach((header) => {
      if (header?.enableFilter && params?.get(header?.filterName)) {
        const value = params?.get(header?.filterName);
        const option = header?.filterOptions?.find(
          (opt) => opt?.value === value,
        );
        if (option) {
          initialFilters[header?.filterName] = option;
        }
      }
    });

    setHeaderFilters(initialFilters);

    // Load search term from query params
    const searchParam = params?.get("search");
    if (searchParam) {
      setSearchItem(searchParam);
    }

    // Load sorting from query params
    const sortColumn = params?.get("sortColumn");
    const sortOrder = params?.get("sortOrder");
    if (sortColumn && sortOrder) {
      if (backendFilter) {
        // Skip sorting if backend filter is enabled
        return;
      } else {
        const header = headers?.find((h) => h?.name === sortColumn);
        if (header) {
          // Add null check for data before sorting
          if (!data || !Array.isArray(data)) {
            setFilteredRow([]);
            return;
          }

          // Add null check for customSorting
          if (!customSorting || !customSorting?.[header?.id]) {
            setFilteredRow([...data]);
            return;
          }

          setSorting({
            header: header,
            column: header?.name,
            order: sortOrder?.toLowerCase(),
            clickCount: 1,
          });
        }
      }
    }
  }, [location?.pathname, props?.headers, location?.search]);

  const resetSorting = () => {
    // Reset frontend sorting
    const resetSortingState = {
      header: null,
      column: null,
      order: "none",
      clickCount: 0,
    };
    setSorting(resetSortingState);

    // Reset backend sorting if enabled
    if (backendFilter) {
      const resetBackendSorting = {
        column: null,
        order: "none",
        clickCount: 0,
      };
      setSelectedsortOption(resetBackendSorting);
    }

    // Clear sorting from URL params
    const params = new URLSearchParams(location?.search);
    params.delete("sortColumn");
    params.delete("sortOrder");
    history?.replace({ search: params?.toString() });

    // Clear sorting from localStorage
    localStorage?.removeItem("tableSorting");

    // Reset filtered data to original data
    setFilteredRow([...data]);
    setLoading(true);
  };

  // Expose resetSorting through props
  useEffect(() => {
    if (props?.resetSorting) {
      props?.resetSorting(resetSorting);
    }
  }, []);

  return (
    <div
      className="w-100"
      style={{ background: "white", borderRadius: "24px" }}
    >
      <div className="w-100 d-flex justify-content-start">
        {props?.disableSearchInput ? (
          <></>
        ) : (
          <div className="table-search-container">
            <div className="table-search-input">
              <Search height={"24px"} width={"24px"} />
              <Input
                inputStyle={{ background: "transparent", border: "none" }}
                className={"w-100"}
                value={searchItem}
                placeholder={"Search ..."}
                onChange={handleSearchChange}
              />
              {searchItem !== "" && (
                <SearchCrossIcon
                  height={"24px"}
                  width={"24px"}
                  cursor={"pointer"}
                  onClick={handleCancelSearch}
                />
              )}
            </div>
          </div>
        )}
      </div>
      <div
        style={{ width: "100%", borderRadius: "24px" }}
        className="table-container"
      >
        {["checked", "indeterminate"].includes(headerCheckboxState) &&
          props.enableCheckbox && (
            <div className="bulk-update-header mt-3">
              <div className="body-2">
                {selectedItemsCount()} Items{" "}
                {!isOnMobileScreen ? "Selected" : ""}
              </div>
              <div style={{ gap: "16px" }} className="body-2 d-flex">
                <span
                  style={{
                    gap: isOnMobileScreen ? "5px" : "10px",
                    borderRadius: "24px",
                    padding: "6px 12px",
                    border: "1px solid #121216",
                  }}
                  className="d-flex align-items-center pointer"
                  onClick={() => {
                    handleBulkUpdate("REJECTED");
                  }}
                >
                  Reject{" "}
                </span>
                <span
                  style={{
                    gap: isOnMobileScreen ? "5px" : "10px",
                    borderRadius: "24px",
                    padding: "6px 12px",
                    background: "#121216",
                    color: "white",
                  }}
                  className="d-flex align-items-center pointer"
                  onClick={() => {
                    handleBulkUpdate("SHORTLISTED");
                  }}
                >
                  Shortlist
                </span>
              </div>
            </div>
          )}
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              {headers &&
                headers?.map((header, index) => {
                  return (
                    <React.Fragment key={index}>
                      {((isOnWebScreen && header.screens.includes("web")) ||
                        (isOnTabletScreen && header.screens.includes("tab")) ||
                        (isOnMiniTabletScreen &&
                          header.screens.includes("mini_tab")) ||
                        (isOnMobileScreen &&
                          header.screens.includes("mob"))) && (
                        <th
                          className={`table-header  ${
                            isOnWebScreen ? "body-2" : "body-3"
                          }`}
                          style={{
                            width: `${
                              props.showNo && index === 0
                                ? "50px"
                                : `${100 / headerLength}%`
                            }`,
                            minWidth: `${
                              props.showNo && index === 0
                                ? "50px"
                                : `${100 / headerLength}%`
                            }`,
                            maxWidth: `${
                              props.showNo && index === 0
                                ? "50px"
                                : `${100 / headerLength}%`
                            }`,
                            textAlign:
                              props.showActions && header.name === "Actions"
                                ? "space-between"
                                : props?.textAlign
                                  ? props?.textAlign
                                  : "space-between",
                          }}
                          key={index}
                          tabIndex={-1}
                          {...focusWithinProps}
                        >
                          <div className="d-flex justify-content-center align-items-center">
                            <div
                              className="w-100 d-flex justify-content-start align-items-center  body-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                !header.disableSorting && setFilteredRow(data);
                              }}
                            >
                              {index === 0 && props.enableCheckbox && (
                                <div style={{ position: "relative" }}>
                                  {headerCheckboxState === "indeterminate" && (
                                    <div
                                      className="indeterminate-checkbox"
                                      onClick={() => {
                                        handleSelectAll();
                                      }}
                                    >
                                      {" "}
                                      <div className="indeterminate-icon"></div>{" "}
                                    </div>
                                  )}
                                  <Checkbox
                                    checked={headerCheckboxState}
                                    onChange={() => {
                                      handleSelectAll();
                                    }}
                                    primary
                                  />
                                </div>
                              )}
                              {header.enableFilter ? (
                                <CustomTooltip
                                  customPosition={{
                                    bottom: "55px",
                                    left: "8px",
                                  }}
                                  text={openFilterCard ? "" : `Click to filter`}
                                >
                                  <div
                                    className={` ${
                                      headerFilters[header.filterName]
                                        ? " table-header-selected-filter"
                                        : ""
                                    } d-flex justify-content-start align-items-center`}
                                    style={{
                                      width: "100%",
                                      cursor: "pointer",
                                      gap: "6px",
                                    }}
                                    onClick={() => {
                                      !header.disableSorting
                                        ? setFilteredRow(data)
                                        : header.enableFilter &&
                                          handleOpenFilterCard(
                                            header.filterName,
                                          );
                                    }}
                                  >
                                    <span
                                      className="body-2"
                                      style={{
                                        color: headerFilters[header.filterName]
                                          ? "white"
                                          : header.enableFilter &&
                                              openFilterCard &&
                                              filterDropdowns ===
                                                header.filterName
                                            ? "#6F2DBD"
                                            : "#808191",
                                      }}
                                    >
                                      {header?.name}
                                    </span>
                                    <>
                                      {headerFilters[header.filterName] && (
                                        <div className="filter-option">
                                          <CustomTooltip
                                            customPosition={{
                                              bottom: "12px",
                                              left: "0px",
                                            }}
                                            text={`${
                                              headerFilters[header.filterName]
                                                .name
                                            } Filter is Applied`}
                                          >
                                            <span className="body-3 text-center">
                                              1
                                            </span>
                                          </CustomTooltip>
                                        </div>
                                      )}
                                      <div
                                        className={`${" d-flex flex-column justify-content-center"}`}
                                        style={{ position: "relative" }}
                                      >
                                        {/* <CustomTooltip
                                          customPosition={{
                                            bottom: "55px",
                                            left: "8px",
                                          }}
                                          text={`Click to filter`}
                                        > */}
                                        <Filter
                                          // onClick={() =>
                                          //   handleOpenFilterCard(
                                          //     header.filterName
                                          //   )
                                          // }
                                          style={{ cursor: "pointer" }}
                                        />
                                        {/* </CustomTooltip> */}
                                        {header.enableFilter &&
                                          openFilterCard &&
                                          filterDropdowns ===
                                            header.filterName && (
                                            <div className="table-filter-card-container d-flex flex-column align-items-start">
                                              <div className="table-filter-card-header">
                                                <span className="body-2 medium black-700">
                                                  Filters
                                                </span>
                                                <span
                                                  className="body-3 dark-100"
                                                  onClick={() =>
                                                    handleResetFIlter(
                                                      header.filterName,
                                                    )
                                                  }
                                                >
                                                  Reset Filter
                                                </span>
                                              </div>
                                              <div className="w-100 d-flex flex-column align-items-start">
                                                <div className="radio-section">
                                                  {header?.filterOptions?.map(
                                                    (option, i) => (
                                                      <>
                                                        <div
                                                          key={i}
                                                          className="select-radio pointer"
                                                          onClick={() =>
                                                            handleFilterChange(
                                                              header.filterName,
                                                              option,
                                                            )
                                                          }
                                                        >
                                                          <input
                                                            readOnly
                                                            type="radio"
                                                            name={
                                                              header.filterName
                                                            }
                                                            value={option}
                                                            checked={
                                                              headerFilters[
                                                                header
                                                                  .filterName
                                                              ]?.value ===
                                                              option.value
                                                            }
                                                          />
                                                          <span className="primary-checkbox-title ms-2 description">
                                                            {option.name}
                                                          </span>
                                                        </div>
                                                      </>
                                                    ),
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </>
                                  </div>
                                </CustomTooltip>
                              ) : !header.disableSorting ? (
                                <CustomTooltip
                                  customPosition={{
                                    bottom: "55px",
                                    left: "0px",
                                  }}
                                  text={`Click to Sort`}
                                >
                                  <div
                                    className={`d-flex justify-content-start align-items-center`}
                                    style={{
                                      width: "max-content",
                                      cursor: "pointer",
                                      gap: "12px",
                                    }}
                                    onClick={() => {
                                      !header.disableSorting &&
                                        handleSort(header);
                                    }}
                                  >
                                    <span
                                      className="body-2"
                                      style={{ color: "#808191" }}
                                    >
                                      {header?.name}
                                    </span>
                                    <div
                                      className=" d-flex flex-column justify-content-center "
                                      style={{ marginLeft: "0px" }}
                                    >
                                      <ArrowUp
                                        style={{
                                          cursor: "pointer",
                                          stroke:
                                            sorting.column === header?.name &&
                                            sorting.order === "asc"
                                              ? "#121216"
                                              : "#808191",
                                        }}
                                      />
                                      <ArrowUp
                                        style={{
                                          cursor: "pointer",
                                          rotate: "180deg",
                                          stroke:
                                            sorting.column === header?.name &&
                                            sorting.order === "desc"
                                              ? "#121216"
                                              : "#808191",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </CustomTooltip>
                              ) : header.backendSorting && backendFilter ? (
                                <CustomTooltip
                                  customPosition={{
                                    bottom: "55px",
                                    left: "0px",
                                  }}
                                  text={`Click to Sort`}
                                >
                                  <div
                                    className={`d-flex justify-content-start align-items-center`}
                                    style={{
                                      width: "max-content",
                                      cursor: "pointer",
                                      gap: "12px",
                                    }}
                                    onClick={() => {
                                      handleBackendSort(header);
                                    }}
                                  >
                                    <span
                                      className="body-2"
                                      style={{ color: "#808191" }}
                                    >
                                      {header?.name}
                                    </span>
                                    <div
                                      className=" d-flex flex-column justify-content-center "
                                      style={{ marginLeft: "0px" }}
                                    >
                                      <ArrowUp
                                        style={{
                                          cursor: "pointer",
                                          stroke:
                                            selectedsortOption.column ===
                                              header?.id &&
                                            selectedsortOption.order === "ASC"
                                              ? "#121216"
                                              : "#808191",
                                        }}
                                      />
                                      <ArrowUp
                                        style={{
                                          cursor: "pointer",
                                          rotate: "180deg",
                                          stroke:
                                            selectedsortOption.column ===
                                              header?.id &&
                                            selectedsortOption.order === "DESC"
                                              ? "#121216"
                                              : "#808191",
                                        }}
                                      />
                                    </div>
                                  </div>
                                </CustomTooltip>
                              ) : (
                                <div
                                  className={`d-flex justify-content-start align-items-center`}
                                  style={{
                                    width: "max-content",
                                    cursor: "pointer",
                                    gap: "12px",
                                  }}
                                  onClick={() => {
                                    !header.disableSorting &&
                                      handleSort(header);
                                  }}
                                >
                                  <span
                                    className="body-2"
                                    style={{ color: "#808191" }}
                                  >
                                    {header?.name}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        </th>
                      )}
                    </React.Fragment>
                  );
                })}
            </tr>
          </thead>
          <tbody>
            {!loading &&
              rows?.map((row, rowIndex) => {
                const rowLength = props.showActions
                  ? headerLength - 1
                  : headerLength;
                const rowKey = row?.id || row?.spec_id || rowIndex;
                return (
                  <React.Fragment key={rowKey}>
                    {props.enableCheckbox && (
                      <div className="select-row-checkbox">
                        <Checkbox
                          onChange={() => handleSelectRow(row?.id)}
                          checked={row["selected"] ? true : false}
                          primary
                        />
                      </div>
                    )}
                    {
                      <tr
                        className="body-3 table-row"
                        style={{
                          background:
                            (props.highlightActiveRow &&
                              activeRow === rowIndex) ||
                            row["selected"]
                              ? "#F4F6F6"
                              : "white",
                        }}
                        onClick={() => {
                          assessSpecRowClick && handleRowClick(row);
                          setActiveRow(rowIndex);
                          setSelectedRow(row);
                          setIsModalOpen(true);
                          onSelectRow && onSelectRow(row);
                          setHighlightActiveRow && setHighlightActiveRow(true);
                        }}
                        key={rowKey}
                      >
                        {row &&
                          headers.map((header, entityIndex) => {
                            const cellKey = header?.id || entityIndex;
                            return (
                              <React.Fragment key={cellKey}>
                                {((isOnWebScreen &&
                                  header.screens.includes("web")) ||
                                  (isOnTabletScreen &&
                                    header.screens.includes("tab")) ||
                                  (isOnMiniTabletScreen &&
                                    header.screens.includes("mini_tab")) ||
                                  (isOnMobileScreen &&
                                    header.screens.includes("mob"))) && (
                                  <td
                                    className="table-col body-2 dark-100"
                                    style={{
                                      paddingLeft:
                                        isOnMobileScreen &&
                                        header.name === "Status"
                                          ? "6px"
                                          : "23px",
                                    }}
                                    key={cellKey}
                                  >
                                    {((headers[entityIndex].type === "string" &&
                                      !headers[entityIndex].timeDifference) ||
                                      headers[entityIndex].type ===
                                        "number") && (
                                      <a
                                        style={{
                                          textDecoration: "none",
                                          color: "black",
                                          width: "max-content",
                                        }}
                                        href={`/dashboard/assessments/${row?.spec_id}?result=${row?.id}`}
                                        onClick={(e) => {
                                          e.preventDefault();
                                        }}
                                      >
                                        {header.id === "hiringStage" ? (
                                          <div
                                            className="table-email-text d-flex align-items-center"
                                            style={{
                                              height: "58px",
                                              width: "100%",
                                            }}
                                          >
                                            {["Pending", "PENDING"].includes(
                                              row[header.id],
                                            )
                                              ? "Not Yet Evaluated"
                                              : row[header.id]}
                                          </div>
                                        ) : (
                                          <div
                                            className="table-email-text d-flex align-items-center"
                                            style={{
                                              height: "58px",
                                              width: "100%",
                                            }}
                                          >
                                            {row[header.id]}
                                          </div>
                                        )}
                                      </a>
                                    )}
                                    {headers[entityIndex].type ===
                                      "component" &&
                                      headers[entityIndex].id !=
                                        "createdBy" && (
                                        <>
                                          <a
                                            style={{
                                              textDecoration: "none",
                                              color: "black",
                                              width: "max-content",
                                            }}
                                          >
                                            <div
                                              className="hover-primary-text d-flex align-items-center"
                                              style={{
                                                height: "58px",
                                                width: "100%",
                                              }}
                                            >
                                              {" "}
                                              {row[header.id]}
                                            </div>
                                          </a>
                                        </>
                                      )}
                                    {headers[entityIndex].type === "string" &&
                                      headers[entityIndex].timeDifference &&
                                      headers[entityIndex].id !=
                                        "updated_at" && (
                                        <a
                                          style={{
                                            textDecoration: "none",
                                            color: "black",
                                            width: "max-content",
                                          }}
                                          href={`/dashboard/assessments/${row?.spec_id}?result=${row?.id}`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                          }}
                                        >
                                          <CustomTooltip
                                            position="top-end"
                                            text={`${formatDate(
                                              new Date(row[header.id]),
                                            )}`}
                                          >
                                            <div
                                              className="hover-primary-text d-flex align-items-center"
                                              style={{
                                                height: "58px",
                                                width: "100%",
                                              }}
                                            >
                                              {" "}
                                              {localTimeDifference(
                                                new Date(row[header.id]),
                                              )}
                                            </div>
                                          </CustomTooltip>
                                        </a>
                                      )}
                                    {headers[entityIndex].type === "string" &&
                                      headers[entityIndex].timeDifference &&
                                      headers[entityIndex].id ===
                                        "updated_at" && (
                                        <a
                                          style={{
                                            textDecoration: "none",
                                            color: "black",
                                            width: "max-content",
                                          }}
                                          href={`/dashboard/assessments/${row?.spec_id}?result=${row?.id}`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                          }}
                                        >
                                          <CustomTooltip
                                            position="top-end"
                                            text={`${formatDate(
                                              new Date(
                                                row[
                                                  "candidate_last_activity"
                                                ] ?? row[header.id],
                                              ),
                                            )}`}
                                          >
                                            <div
                                              className="hover-primary-text d-flex align-items-center"
                                              style={{
                                                height: "58px",
                                                width: "100%",
                                              }}
                                            >
                                              {" "}
                                              {localTimeDifference(
                                                new Date(
                                                  row[
                                                    "candidate_last_activity"
                                                  ] ?? new Date(row[header.id]),
                                                ),
                                              )}
                                            </div>
                                          </CustomTooltip>
                                        </a>
                                      )}

                                    {headers[entityIndex].type ===
                                      "component" &&
                                      headers[entityIndex].id ===
                                        "createdBy" && (
                                        <>
                                          {row["author"]?.first_name &&
                                            row["author"]?.last_name && (
                                              <a
                                                style={{
                                                  textDecoration: "none",
                                                  color: "black",
                                                  width: "max-content",
                                                }}
                                              >
                                                <div
                                                  className="hover-primary-text d-flex align-items-center"
                                                  style={{
                                                    height: "58px",
                                                    width: "100%",
                                                  }}
                                                >
                                                  {" "}
                                                  {row["author"]?.first_name +
                                                    " " +
                                                    row["author"]?.last_name}
                                                </div>
                                              </a>
                                            )}
                                        </>
                                      )}
                                    {headers[entityIndex].type === "date" && (
                                      <span>
                                        {new Date(
                                          row[header.id],
                                        ).toLocaleTimeString()}
                                      </span>
                                    )}
                                  </td>
                                )}
                              </React.Fragment>
                            );
                          })}
                        {props.showActions && <td className="py-4 px-2"></td>}
                      </tr>
                    }
                  </React.Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
      {loading && (
        <div
          className="w-100 d-flex flex-column align-items center justify-content-center"
          style={{ height: "190px" }}
        >
          <ProcessingIndicator />
        </div>
      )}
      {filteredData === null || !filteredData?.length ? (
        <>
          {props?.nullTableLoading ? (
            <div
              className="w-100 d-flex flex-column align-items center justify-content-center"
              style={{ height: "190px" }}
            >
              <ProcessingIndicator />
            </div>
          ) : (
            <div className="empty-table-text" style={{ gap: "12px" }}>
              <span className="subtitle-2 dark-100">
                {props.nullTableTitle}
              </span>
              <span className="body-2 dark-50">
                {props.nullTableDescription}
              </span>
            </div>
          )}
        </>
      ) : (
        <>
          {props?.disablePagination ? (
            <></>
          ) : (
            <div>
              {filteredRow?.length && (
                <>
                  <div
                    className="table-show-rows-select d-flex align-items-center  py-0 mt-3"
                    style={{ width: "275px", gap: "12px" }}
                  >
                    <label className="body-2  dark-50 w-100">
                      Rows per page
                    </label>
                    <Select
                      options={[
                        { name: "10", value: 10 },
                        { name: "25", value: 25 },
                        { name: "50", value: 50 },
                        { name: "100", value: 100 },
                      ]}
                      onSelection={(option) => {
                        setRowsPerPage(option.value);
                        setCurrentPage(1);
                        if (props.onRowsPerPageChange) {
                          props.onRowsPerPageChange(option.value);
                        }
                      }}
                      // title={'Rows per page'}
                      selected={rowsPerPage}
                      placeholder={"Choose"}
                      titleStyle={{ color: "#6E6B7B" }}
                      innerStyle={{ width: "120px" }}
                    />
                  </div>
                  {backendFilter ? (
                    <div className="table-pagination-container">
                      <span className="body-2 dark-50">{`Showing ${
                        (props.currentPage - 1) * props.itemsPerPage + 1
                      } - ${Math.min(
                        props.currentPage * props.itemsPerPage,
                        props.totalItems,
                      )} `}</span>
                      <span className="body-2 dark-100">{` of ${props.totalItems}`}</span>
                      <BackArrow
                        className="pointer"
                        style={{
                          width: "20px",
                          height: "20px",
                          opacity:
                            props.totalItems <= props.itemsPerPage ||
                            props.currentPage <= 1
                              ? 0.5
                              : 1,
                          cursor:
                            props.totalItems <= props.itemsPerPage ||
                            props.currentPage <= 1
                              ? "not-allowed"
                              : "pointer",
                        }}
                        onClick={() => {
                          if (
                            props.totalItems > props.itemsPerPage &&
                            props.currentPage > 1
                          )
                            props.prevSlide();
                        }}
                      />
                      <ForwardArrow
                        className="pointer"
                        style={{
                          width: "20px",
                          height: "20px",
                          opacity:
                            props.totalItems <= props.itemsPerPage ||
                            props.currentPage >= props.totalPages
                              ? 0.5
                              : 1,
                          cursor:
                            props.totalItems <= props.itemsPerPage ||
                            props.currentPage >= props.totalPages
                              ? "not-allowed"
                              : "pointer",
                        }}
                        onClick={() => {
                          if (
                            props.totalItems > props.itemsPerPage &&
                            props.currentPage < props.totalPages
                          )
                            props.nextSlide();
                        }}
                      />
                    </div>
                  ) : (
                    <div className="table-pagination-container">
                      <span className="body-2 dark-50">{`Showing ${
                        filteredRow.length === 0
                          ? 0
                          : filteredRow.length <= rowsPerPage
                            ? 1
                            : start + 1
                      }-${
                        filteredRow.length <= rowsPerPage
                          ? filteredRow.length
                          : Finish > filteredRow.length
                            ? filteredRow.length
                            : Finish
                      }`}</span>
                      <span className="body-2 dark-100">{` of ${filteredRow.length}`}</span>
                      <BackArrow
                        className="pointer"
                        style={{
                          width: "20px",
                          height: "20px",
                          opacity:
                            filteredRow.length <= rowsPerPage || start < 1
                              ? 0.5
                              : 1,
                          cursor:
                            filteredRow.length <= rowsPerPage || start < 1
                              ? "not-allowed"
                              : "pointer",
                        }}
                        onClick={() => {
                          if (filteredRow.length > rowsPerPage && start >= 1) {
                            prevSlide();
                            if (currentPage === 2) {
                              const params = new URLSearchParams(
                                location?.search,
                              );
                              params.delete("page");
                              history?.replace({ search: params?.toString() });
                              localStorage?.removeItem("page");
                            }
                          }
                        }}
                      />
                      <ForwardArrow
                        className="pointer"
                        style={{
                          width: "20px",
                          height: "20px",
                          opacity:
                            filteredRow.length <= rowsPerPage ||
                            Finish >= filteredRow.length
                              ? 0.5
                              : 1,
                          cursor:
                            filteredRow.length <= rowsPerPage ||
                            Finish >= filteredRow.length
                              ? "not-allowed"
                              : "pointer",
                        }}
                        onClick={() => {
                          if (
                            filteredRow.length > rowsPerPage &&
                            Finish < filteredRow.length
                          )
                            nextSlide();
                        }}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
